import api from '../../../utils/api';
import { MarketDataPath } from './enums';

export default class MarketDataApiService {
  static shareSearchByEmail(body) {
    return api.post(
      `${MarketDataPath.ShareSearch}`,
      body,
    );
  }
}
